import { lazy } from 'react';

// import { default as Holiday } from './Holiday';
const Holiday = lazy(() => import(/* webpackChunkName: "Holiday" */ './Holiday'));
export { Holiday };



// WEBPACK FOOTER //
// src/modules/screens/settings/Holiday/components/index.js